import React from "react";
import { ActivityCertificateContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { ROUTE_PATH } from "utils/constants/routePath";
import { IMG_PATH } from "utils/constants/imgPath";
import { userService } from "apiServices";
import { toast } from "react-toastify";
import { Buttons, Displays, Forms, Headers, Icons } from "components";
import ImageSmooth from "components/Displays/ImageSmooth";

/**
 * หน้ารับ Certificate หลังสแกน qrcode ครบเงื่อนไข (activity offline + condition_type "5" + gift_type "4")
 *
 * step 1 กรอกชื่อ/นามสกุล/อีเมล (prefill จากโปรไฟล์ แก้ได้)
 * step 2 ยืนยันข้อมูล
 * step 3 สำเร็จ
 *
 * componentDidMount ทำหน้าที่เป็นทั้ง guard และจุด resume — ถ้าลูกค้าปิดแอปกลางทาง
 * แล้วกลับเข้ามาใหม่จะต่อจากสถานะจริงบน server เสมอ ไม่เก็บ state ไว้ฝั่ง client
 */
class ActivityCertificateContainer extends React.Component {
  _isSubmitting = false;

  state = {
    isLoading: true,
    step: 1,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { authenRedux, router, t } = this.props;
    const activityId = router.params?.id;

    let resArr = await Promise.all([
      userService.GET_ACTIVITY_DETAIL(activityId),
      userService.GET_ACTIVITY_HISTORY_BY_ME_ACTIVITY(
        activityId,
        authenRedux.member_type_active,
      ),
    ]);

    if (!resArr || resArr[0].status !== 200) {
      this.setState({ isLoading: false });
      this.handleBackToActivity();
      return;
    }

    const data = resArr[0].data;
    const activityRegisData = resArr[1]?.data ? resArr[1].data : false;

    // ตกลงกันไว้ว่าออกใบให้เฉพาะสมาชิกบุคคล
    if (authenRedux.member_type_active !== "1") {
      this.setState({ isLoading: false });
      toast.error(t("Certificate for individual member only", { ns: "common" }));
      this.handleBackToActivity();
      return;
    }

    const isCertificateActivity =
      !!activityRegisData &&
      activityRegisData.activity_type === "2" &&
      activityRegisData.activity_condition_type === "5" &&
      activityRegisData.activity_gift_type === "4";

    if (!isCertificateActivity || activityRegisData.status !== "2") {
      this.setState({ isLoading: false });
      toast.error(t("Certificate not available", { ns: "common" }));
      this.handleBackToActivity();
      return;
    }

    // ออกใบไปแล้ว → ข้ามไปจอสำเร็จเลย พร้อมลิงก์โหลดซ้ำ
    if (activityRegisData.certificate_generate_history_ref_id) {
      this.setState({
        data,
        activityRegisData,
        generateHistoryId:
          activityRegisData.certificate_generate_history_ref_id,
        isLoading: false,
        step: 3,
      });
      return;
    }

    this.setState({
      data,
      activityRegisData,
      initialValues: {
        first_name: authenRedux.first_name || "",
        last_name: authenRedux.last_name || "",
        email: authenRedux.email || "",
      },
      isLoading: false,
      step: 1,
    });
  };

  handleSubmitForm = (values) => {
    this.setState({ formValues: values, step: 2 });
  };

  handleBackToEdit = () => {
    const { formValues } = this.state;
    this.setState({ initialValues: formValues, step: 1 });
  };

  handleConfirm = async () => {
    const { router, t } = this.props;
    const { formValues } = this.state;
    // กันกดรัว — setState เป็น async กันไม่ทัน ต้องใช้ ref
    if (this._isSubmitting) return;
    this._isSubmitting = true;
    this.setState({ isBgLoading: true });

    let res = await userService.POST_ACTIVITY_HISTORY_CERTIFICATE({
      activity_id: router.params?.id,
      first_name: formValues.first_name,
      last_name: formValues.last_name,
      email: formValues.email,
      member_type: this.props.authenRedux.member_type_active,
    });

    this._isSubmitting = false;
    if (res && res.status === 200) {
      this.setState({
        isBgLoading: false,
        generateHistoryId: res.data?.certificate_generate_history_id,
        step: 3,
      });
    } else {
      this.setState({ isBgLoading: false });
      toast.error(
        res?.data?.error?.code === "CERTIFICATE_EXPIRED"
          ? t("Certificate expired", { ns: "common" })
          : res?.data?.error?.message ||
              t("Certificate request failed", { ns: "common" }),
      );
    }
  };

  handleBackToActivity = () => {
    this.props.router.navigate(
      `${ROUTE_PATH.ACTIVITIES}/${this.props.router.params?.id}`,
    );
  };

  handleGoHome = () => {
    this.props.router.navigate(ROUTE_PATH.HOME);
  };

  handleDownloadNow = () => {
    const { generateHistoryId } = this.state;
    if (generateHistoryId) {
      this.props.router.navigate(
        `${ROUTE_PATH.CERIFICATE}/${generateHistoryId}`,
      );
    }
  };

  render() {
    const { t } = this.props;
    const {
      isLoading,
      isBgLoading,
      step,
      data,
      initialValues,
      formValues,
      generateHistoryId,
    } = this.state;

    return (
      <ActivityCertificateContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="certificate_container">
          <Headers.NewPageHeader title={"CERTIFICATE"} sub_title={"ประกาศนียบัตร"} />
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              {data && step !== 3 && (
                <div className="activity_img_wrap">
                  <ImageSmooth
                    alt="activity"
                    src={
                      data.img
                        ? IMG_PATH + data.img
                        : "/assets/images/mockups/activities-1.jpg"
                    }
                    aspectRatio="16 / 9"
                  />
                </div>
              )}

              {step === 1 && (
                <>
                  <div className="step_desc">
                    {t(
                      "Thank you for participating in the activity. Please check your name and email so we can send your certificate.",
                      { ns: "common" },
                    )}
                  </div>
                  <Forms.ActivityCertificateForm
                    initialValues={initialValues}
                    onSubmit={this.handleSubmitForm}
                  />
                </>
              )}

              {step === 2 && (
                <>
                  <div className="step_title">
                    {t("Confirm your information", { ns: "common" })}
                  </div>
                  <div className="confirm_box">
                    <div className="cb_item">
                      <div className="cb_label">
                        {t("First name", { ns: "common" })}
                      </div>
                      <div className="cb_value">{formValues?.first_name}</div>
                    </div>
                    <div className="cb_item">
                      <div className="cb_label">
                        {t("Last name", { ns: "common" })}
                      </div>
                      <div className="cb_value">{formValues?.last_name}</div>
                    </div>
                    <div className="cb_item">
                      <div className="cb_label">
                        {t("Email (for receiving image files)", {
                          ns: "common",
                        })}
                      </div>
                      <div className="cb_value">{formValues?.email}</div>
                    </div>
                  </div>
                  <div className="btn_wrap">
                    <Buttons.BgStandard
                      label={t("Confirm", { ns: "common" })}
                      onClick={this.handleConfirm}
                    />
                  </div>
                  <div className="btn_wrap">
                    <Buttons.BgStandard
                      theme_gray
                      label={t("Edit", { ns: "common" })}
                      onClick={this.handleBackToEdit}
                    />
                  </div>
                </>
              )}

              {step === 3 && (
                <>
                  <div className="result_section">
                    <div className="result_icon">
                      <Icons.Success width={80} height={80} />
                    </div>
                    <div className="result_title">
                      {t("Confirmation successful", { ns: "common" })}
                    </div>
                    <div className="result_sub_title">
                      {t(
                        "We will send your certificate to the email you provided.",
                        { ns: "common" },
                      )}
                    </div>
                  </div>
                  <div className="btn_wrap">
                    <Buttons.BgStandard
                      label={t("Home", { ns: "common" })}
                      onClick={this.handleGoHome}
                    />
                  </div>
                  {generateHistoryId && (
                    <div className="btn_wrap">
                      {/* เผื่ออีเมลไม่เข้า ให้โหลดจากในแอปได้เลย */}
                      <Buttons.BgStandard
                        theme_gray
                        label={t("Download now", { ns: "common" })}
                        onClick={this.handleDownloadNow}
                      />
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </ActivityCertificateContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(["common"])(withRouter(ActivityCertificateContainer)));
